import ICarrierFormData from '../../../../../common/interfaces/ICarrierFormData';
import IContact from '../../../../../common/interfaces/IContacts';
import IValidationResult from '../../../../../common/interfaces/IValidationResult';
import { getCarrierAxiosInstance } from '../../../../../common/services/axios-config';
import ValidationService from '../../../../../common/services/validation';
import { SerializerDecimal } from '../../../../../utils/formatterDecimal';
import ISaveCarrierContactRequest from '../../../../branches/interfaces/ISaveCarrierContactRequest';
import ISaveCarrierRequest from '../../../../branches/interfaces/ISaveCarrierRequest';
import { ICarrierResponse } from '../../../interfaces/ICarrierResponse';
import ICarriersFiltersModel from '../../../interfaces/ICarriersFiltersModel';
import IUpdateCarrier from '../../../interfaces/IUpdateCarrier';
import IValidEgatesIdModel from '../../../interfaces/IValidEgatesIdModel';
import CarriersService from '../../../services/carriers.service';
import {
    GeneralValidationSchema,
    ValidEgatesId,
} from './carrier-form.validation.service';

const validateInfos = (carrierData: ICarrierFormData): IValidationResult => {
    return ValidationService.validate(GeneralValidationSchema, carrierData);
};

const saveCarrier = async (
    carrierData: ICarrierFormData,
    t: (key: string) => string, // função de tradução
): Promise<string> => {
    const api = await getCarrierAxiosInstance();

    const request: ISaveCarrierRequest = {
        tradeName: carrierData.tradeName,
        paymentTerm: SerializerDecimal(carrierData.paymentTerm),
        contacts: [createContact(carrierData.carriersContact)],
        carrierId: carrierData.id,
        legacy: carrierData.legacy ? carrierData.legacy : false,
    };

    try {
        const { data } = await api.post(`v1/carriers`, request);
        return data;
    } catch {
        throw new Error(t('TransportadoraErroAdicionar'));
    }
};

const validEgatesId = async (
    carrierData: ICarrierFormData,
    t: (key: string) => string,
    isDeleted?: boolean,
    carrierId?: string,
): Promise<IValidationResult> => {
    const request: ICarriersFiltersModel = {
        legacy: true,
        sulaHubId: carrierData.id,
        IsDeleted: isDeleted,
    };

    let response;
    if (carrierData.id) {
        response = await CarriersService.getCarriersList(1, 10, request);

        if (!!carrierId && response.data.some(c => c.id === carrierId)) {
            response.data = response.data.filter(c => c.id !== carrierId);
            response.totalItems -= 1;
        }
    }

    const data: IValidEgatesIdModel = {
        sulaHubId: carrierData.id,
        legacy: carrierData.legacy,
        existingCarriers: response,
    };
    return ValidationService.validate(ValidEgatesId, data);
};

const getCarrierById = async (
    carrierId: string,
    t: (key: string) => string, // função de tradução
): Promise<ICarrierResponse> => {
    const api = await getCarrierAxiosInstance();
    const response = await api.get(`v1/carriers/${carrierId}`).catch(() => {
        throw new Error(t('TransportadoraErroConsultarMatriz'));
    });

    return response.data as ICarrierResponse;
};

const isLegacyCarrier = (sulaHubId: string): boolean =>
    sulaHubId.startsWith('L');

const updateCarrier = async (
    carrierId: string,
    carrierData: ICarrierFormData,
    t: (key: string) => string, // função de tradução
): Promise<void> => {
    const api = await getCarrierAxiosInstance();

    const request: IUpdateCarrier = {
        carrierId: carrierData.id!,
        paymentTerm: carrierData.paymentTerm!.toString().replace(',', '.'),
        legacy: carrierData.legacy!,
        carrierContact: {
            contactId: carrierData.carriersContact.id,
            phone: carrierData.carriersContact.phone,
            email: carrierData.carriersContact.email,
            responsible: carrierData.carriersContact.responsible,
            occupation: carrierData.carriersContact.occupation,
            contactType: carrierData.carriersContact.contactType,
            mainContact: carrierData.carriersContact.mainContact,
        },
    };

    try {
        const { data } = await api.put(`v1/carriers/${carrierId}`, request);
        return data;
    } catch {
        throw new Error(t('TransportadoraErroAtualizar'));
    }
};

function createContact(contact: IContact): ISaveCarrierContactRequest {
    return {
        phone: contact.phone,
        email: contact.email,
        occupation: contact.occupation,
        responsible: contact.responsible,
        contactType: contact.contactType,
        mainContact: true,
    } as ISaveCarrierContactRequest;
}

const CarrierFormService = {
    saveCarrier,
    validateInfos,
    validEgatesId,
    getCarrierById,
    isLegacyCarrier,
    updateCarrier,
};

export default CarrierFormService;
